export const iconFontAwesomePhotosImagesFileImage = (
	<i className="fa-solid fa-file-image"></i>
);
